import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function Search({ color = colors.gray['100'], ...props }: Props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.125 9.16667C3.125 5.82995 5.82995 3.125 9.16667 3.125C12.5034 3.125 15.2083 5.82995 15.2083 9.16667C15.2083 12.5034 12.5034 15.2083 9.16667 15.2083C5.82995 15.2083 3.125 12.5034 3.125 9.16667ZM9.16667 1.875C5.13959 1.875 1.875 5.13959 1.875 9.16667C1.875 13.1937 5.13959 16.4583 9.16667 16.4583C10.9552 16.4583 12.5933 15.8144 13.8619 14.7457L16.2247 17.1086C16.4688 17.3527 16.8645 17.3527 17.1086 17.1086C17.3527 16.8645 17.3527 16.4688 17.1086 16.2247L14.7457 13.8619C15.8144 12.5933 16.4583 10.9552 16.4583 9.16667C16.4583 5.13959 13.1937 1.875 9.16667 1.875Z"
        fill={color}
      />
    </svg>
  );
}
